import { render } from "./PopupReportBug.vue?vue&type=template&id=484b09ec&scoped=true"
import script from "./PopupReportBug.vue?vue&type=script&lang=js"
export * from "./PopupReportBug.vue?vue&type=script&lang=js"

import "./PopupReportBug.vue?vue&type=style&index=0&id=484b09ec&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484b09ec"]])

export default __exports__